import Banner from '@/components/Banner2';
import Module from './components/Module.vue';
import Title from '@/components/Title/index.vue';
import OurAdvanteges from './components/Advantages.vue';
import Appointment2 from '@/components/Appointment2/index.vue';
export default {
  components: {
    Banner,
    Module,
    Title,
    OurAdvanteges,
    Appointment2
  },
  data() {
    return {
      imageUrl: require('@/assets/images/service/investment-assistant/investmentAssistant-banner.png'),
      bannerTitle: '智能投资助理',
      bannerText: '将语音识别技术、语义分析与识别技术应用于证券交易场景，为用户提供高质量的股市信息、股市预测、人工智能交互等服务，提升用户交互体验。',
      btnText: 'Free trial',
      moduleList: [{
        img: require('@/assets/images/service/investment-assistant/assistant-module1.png'),
        title: '多平台访问',
        desc1: '支持网站（PC +手机）、APP、抖音、微信（公众号+小程序+ H5 +企业微信）、微博、邮箱、短信等渠道接入，统一平台管理',
        desc2: '支持视频、文字、语音、文件、图片、面部表情、远程辅助等所有媒体和功能，以方便用户与客服快速沟通',
        layout: 'left'
      }, {
        img: require('@/assets/images/service/investment-assistant/assistant-module2.png'),
        title: '专业知识库建设',
        desc1: '机器人从会话记录中自动学习新知识，人工辅助判断知识库的智能管理和维护是机器人维护的核心',
        desc2: '支持视频、文字、语音、文件、图片、面部表情、远程辅助等所有媒体和功能，以方便用户与客服快速沟通',
        layout: 'right'
      }, {
        img: require('@/assets/images/service/investment-assistant/assistant-module3.png'),
        title: '专业视觉数据报告',
        desc1: '各模块数据结果的呈现，以帮助管理者快速了解服务运营情况，有效分析服务运营数据，从而调整和优化',
        desc2: '通过挖掘更深层次的数据价值和数据可视化报表的直观呈现，企业管理者可以准确定位用户关注点，提前发现经营风险，量化评估当前企业服务质量，进行自我驱动的精细化运营。',
        layout: 'left'
      }, {
        img: require('@/assets/images/service/investment-assistant/assistant-module4.png'),
        title: '成本降低效益提高',
        desc1: '通过投资助手可以完成选股、行情诊断、百科全书等功能，该客服建立了一套客服系统，相当于该APP具有“选股、股票诊断、资讯、百科全书”等功能。',
        desc2: '建立一个系统，可以替代50%的人工工作量，以10人的企业座位规模为例，每年可以节约50万人的人工成本，解决人工成本问题。',
        layout: 'right'
      }],
      userList: [{
        img: require('@/assets/images/service/investment-assistant/assistant-ths.png'),
        desc: '金融投资助理“小花”'
      }, {
        img: require('@/assets/images/service/investment-assistant/assistant-zszq.png'),
        desc: '证券投资助理'
      }, {
        img: require('@/assets/images/service/investment-assistant/assistant-zgyd.png'),
        desc: '智能助理'
      }]
    };
  }
};